import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TopBarActions } from "src/redux/TopBar/actions";
import { VIEWS } from "src/redux/TopBar/constants";
import styles from "./styles.module.scss";
import Positions from "./Positions";
import LoanAllocations from "./LoanAllocations";
import Reporting from "./Reporting";

const CLIENT_POOL_TABS = {
    positions: { key: "positions", label: "Positions", component: Positions },
    loanAllocations: {
        key: "loanAllocations",
        label: "Loan Allocations",
        component: LoanAllocations,
    },
    reporting: { key: "reporting", label: "Reporting", component: Reporting },
};

const ClientPool = () => {
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState(CLIENT_POOL_TABS.positions.key);

    useEffect(() => {
        dispatch(TopBarActions.SetView(VIEWS.CLIENT_POOL));
    }, [dispatch]);

    return (
        <div className={styles.clientPool}>
            <div className={styles.header}>
                <div className={styles.title}>Client Pool</div>
            </div>
            <div className={styles.nav}>
                <Tabs
                    activeTab={activeTab}
                    tabOptions={CLIENT_POOL_TABS}
                    onTabChange={setActiveTab}
                />
            </div>
            <div className={styles.body}>
                {React.createElement(CLIENT_POOL_TABS[activeTab].component)}
            </div>
        </div>
    );
};

const Tabs = ({ activeTab, tabOptions, onTabChange }) => {
    return (
        <>
            {Object.values(tabOptions).map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={`${styles.tabBtn}${
                        activeTab === tab.key ? ` ${styles.active}` : ""
                    }`}
                >
                    {tab.label}
                </button>
            ))}
        </>
    );
};

export default ClientPool;
